var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[(_vm.maxValue != 0)?_c('div',{staticClass:"graph"},[_c('div',{staticClass:"bar",style:({ width: _vm.barWidth + '%' })})]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }